export default {
  data: function data() {
    return {
      t_btnThrottle: null,
      t_btnDisabled: false
    };
  },

  methods: {
    // 所有成功操作统一message弹窗及文案
    successMessage: function successMessage() {
      this.$message({
        type: "success",
        message: "操作成功"
      });
    },

    // 去掉树形结构中的返回的空数组。责任单位，责任部门
    recursiveDelProto: function recursiveDelProto(arr, prototype) {
      var _this = this;

      if (!Array.isArray(arr) || arr.length < 1) return;

      arr.forEach(function (elem) {
        if (elem[prototype] && elem[prototype].length > 0) {
          _this.recursiveDelProto(elem[prototype], prototype);
        } else {
          delete elem[prototype];
        }
      });
      return arr;
    },

    // 按钮节流：当持续触发事件时，保证一定时间段内只调用一次事件处理函数。例：表单提交按钮防止重复点击
    formBtnThrottle: function formBtnThrottle(fun) {
      var _this2 = this;

      if (!this.t_btnThrottle) {
        this.t_btnDisabled = true;
        this.t_btnThrottle = new Date().getTime();
        fun().finally(function () {
          _this2.t_btnDisabled = false;
          _this2.t_btnThrottle = null;
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/mixin.js
// module id = null
// module chunks = 